import React, { Component, Fragment } from 'react';

import { token } from '@atlaskit/tokens';
import AkEditorAddonIcon from '@atlaskit/icon/glyph/editor/addon';
import { JiraIcon as AkJiraIcon } from '@atlaskit/logo/jira-icon';

import {
	MacroExperienceSuccess,
	getMacroAttributesFromADFNode,
	getExperienceName,
} from '@confluence/macro-tracker';
import { INLINE_EXTENSION_TYPE } from '@confluence/fabric-extension-lib/entry-points/extensionConstants';

import type { ComponentProps } from './types';

export class DeadMacroRenderer extends Component<ComponentProps> {
	render() {
		const { node, mode, extensionKey, contentId } = this.props;
		const attributes = getMacroAttributesFromADFNode(node);

		const label = node?.parameters?.macroMetadata?.title;
		const isJiraMacro = node.extensionKey.indexOf('jira') !== -1;
		const icon = isJiraMacro ? (
			<AkJiraIcon size="small" label={label} />
		) : (
			<AkEditorAddonIcon label={label} />
		);

		const Element = 'div';

		// this seems counterintuitive, but all inline extensions have a parent <span> with a small width (~38px),
		// so setting 100% width on it only makes it 38px wide and doesn't allow us to include the name of the extension.
		// So, let's force it to be sufficiently large.
		const isInline = node.type === INLINE_EXTENSION_TYPE;
		const width = isInline ? '680px' : '100%';

		return (
			<Fragment>
				<Element
					data-testid="dead-macro-icon"
					style={{
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						display: 'inline-block',
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						backgroundColor: token('color.icon.inverse', '#F4F5F7'),
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						borderRadius: 5,
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						width,
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						height: 25,
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						padding: token('space.050', '4px'),
					}}
				>
					{icon}
					<span
						style={{
							// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
							paddingLeft: token('space.050', '4px'),
							// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
							position: 'absolute',
						}}
					>
						{label}
					</span>
				</Element>
				<MacroExperienceSuccess
					name={getExperienceName(mode, node)}
					contentId={contentId}
					extensionKey={extensionKey}
					mode={mode}
					attributes={attributes}
				/>
			</Fragment>
		);
	}
}
